import { Styles, generateClasses } from 'netline-ui';

export const mobileAboutDialogClasses = generateClasses('MobileAboutDialog', [
  'container',
  'header',
  'closeIcon',
  'title',
  'copyButton',
  'contentTitle',
  'content',
] as const);

const styles: Styles = ({ theme: { colors, spacing } }) => ({
  [`.${mobileAboutDialogClasses.container}`]: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  [`.${mobileAboutDialogClasses.header}`]: {
    flexShrink: 0,
    backgroundColor: colors.grey[300],
    padding: spacing(1.5, 2),
    display: 'flex',
    alignItems: 'center',
    gap: spacing(2),
    '.MuiIconButton-root': {
      padding: 2,
    },
  },
  [`.${mobileAboutDialogClasses.closeIcon}`]: {
    color: colors.grey[900],
    width: '24px',
    height: '24px',
  },
  [`.${mobileAboutDialogClasses.title}`]: {
    color: colors.grey[900],
    fontWeight: 500,
    fontSize: 20,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  [`.${mobileAboutDialogClasses.copyButton}`]: {
    marginLeft: 'auto',
  },
  [`.${mobileAboutDialogClasses.content}`]: {
    flex: 1,
    margin: spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
  [`.${mobileAboutDialogClasses.contentTitle}`]: {
    fontWeight: 700,
    fontSize: 32,
    letterSpacing: '0.25px',
  },
});

export default styles;
